<h4 class="heading">{{region.name}}</h4>
<div class="region-container">
  <mat-card *ngFor="let pollen of getPollenSortedByNameAscending()" class="mat-elevation-z2 pollen-card">
    <mat-card-header>
      <mat-card-title>{{pollen.name}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="day-container">
      <app-pollenflug-tag header="Heute"
                          [belastungsstufe]="pollen.tag00.belastungsstufe"
                          [tendenz]="pollen.tag00.tendenz_tag00_tag01">
      </app-pollenflug-tag>
      <app-pollenflug-tag *ngIf="pollen.tag01"
                          header="Morgen"
                          [belastungsstufe]="pollen.tag01.belastungsstufe"
                          [tendenz]="pollen.tag01.tendenz_tag01_tag02">
      </app-pollenflug-tag>
      <app-pollenflug-tag *ngIf="pollen.tag02"
                          header="Übermorgen"
                          [belastungsstufe]="pollen.tag02.belastungsstufe">
      </app-pollenflug-tag>
    </mat-card-content>
  </mat-card>
</div>
